<div class="row">
  <div class="col-12">
    @if (treeDataSig()?.content?.length > 0) {
      <plyca-ui-tree
        [config]="{
          node: treeDataSig().content,
          style: { 'min-width': '50rem', border: '1px solid #c8c8c8' },
          tableHeader: treeHeader,
          hasActions: true
        }"
        (nodeExpandedChange)="onNodeExpand($event)"
      >
        <ng-template #tableTemplateBody let-data>
          <td class="action-column-4buttons">
            <div class="btn-group">
              <plyca-ui-button-generic
                [config]="{
                  buttonClass: 'btn btn-outline-secondary btn-sm t-action-button buttons-actions ',
                  type: 'button'
                }"
                tabindex="-1"
                title="Edit"
                (clickEvent)="onClickButton(treeDemoEnum.EDIT, data)"
              >
                <span>
                  <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                </span>
              </plyca-ui-button-generic>
              <plyca-ui-button-generic
                [config]="{
                  buttonClass: 'btn btn-outline-secondary btn-sm t-action-button buttons-actions ',
                  type: 'button'
                }"
                tabindex="-1"
                title="Add"
                (clickEvent)="onClickButton(treeDemoEnum.ADD_FROM_BUTTON, data)"
              >
                <span>
                  <i class="fa fa-plus-square-o fa-lg" aria-hidden="true"></i>
                </span>
              </plyca-ui-button-generic>
              @if (data.node.isLastNode) {
                <plyca-ui-button-generic
                  [config]="{
                    buttonClass: 'btn btn-outline-secondary btn-sm t-action-button buttons-actions ',
                    type: 'button'
                  }"
                  tabindex="-1"
                  title="Duplicate"
                  (clickEvent)="onClickButton(treeDemoEnum.DOUBLE, data)"
                >
                  <span>
                    <i class="fa fa-files-o fa-lg" aria-hidden="true"></i>
                  </span>
                </plyca-ui-button-generic>
              }
              <plyca-ui-button-generic
                [config]="{
                  buttonClass: 'btn btn-outline-secondary btn-sm t-action-button buttons-actions ',
                  type: 'button'
                }"
                tabindex="-1"
                title="Delete"
                (clickEvent)="onClickButton(treeDemoEnum.DELETE, data)"
              >
                <span>
                  <i [class]="'fa fa-trash-o fa-lg'" aria-hidden="true"></i>
                </span>
              </plyca-ui-button-generic>
            </div>
          </td>
        </ng-template>
      </plyca-ui-tree>
    } @else {
      <div class="no-data-message">
        <p>{{ 'Data not found' }}</p>
      </div>
    }
  </div>
</div>
